module.exports = __webpack_public_path__ + "static/media/corporate-services-img84.81fe728a.jpg";